import React from "react";
import { Modal, Button } from "@themesberg/react-bootstrap";

function ConfirmActionModal({
  show,
  handleClose,
  title,
  subTitle,
  handleAction,
  actionTitle,
  closeTitle,
  disableButtons
}) {
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{subTitle}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={disableButtons}>
            {closeTitle}
          </Button>
          <Button variant="primary" onClick={handleAction} disabled={disableButtons}>
            {actionTitle}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
ConfirmActionModal.defaultProps = {
  title: "Custom Modal",
  subTitle: "Custom Message",
};

export default ConfirmActionModal;
